/* eslint-disable @typescript-eslint/no-require-imports */

import type { LogEvent, Logger } from './types';

export const logger: Logger<LogEvent> =
  typeof window === 'undefined'
    ? require('./server-side-logger/server-side-logger').serverLogger
    : require('./client-side-logger/client-side-logger').clientLogger;
